import {
	AgreedToTermsActionTypes,
	RESET_AGREED_TO_TERMS,
	SET_AGREED_TO_TERMS,
} from './agreedToTermsActionTypes';

export const setAgreedToTerms = (agreedToTerms: boolean): AgreedToTermsActionTypes => ({
	type: SET_AGREED_TO_TERMS,
	payload: agreedToTerms,
});

export const resetAgreedToTerms = (): AgreedToTermsActionTypes => ({
	type: RESET_AGREED_TO_TERMS,
});
